module.exports = __webpack_public_path__ + "img/UTQUAI-1.007170fc.jpg";